jQuery(document).ready(function ($) {
    $('.faq-block .single-faq').on('click', function() {
        $(this).children().last().slideToggle();
        $(this).toggleClass('active');
    });
});